var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{ref:"list",staticClass:"list-section"},[_c('backbar',{attrs:{"title":_vm.title}}),_vm._v(" "),(_vm.list.length > 0)?_c('book-list',{attrs:{"book-list":_vm.list}}):_vm._e(),_vm._v(" "),(_vm.isEnding)?_c('div',{staticClass:"no-more"},[_vm._v("没有更多了")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17728ade","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/list.vue
// module id = null
// module chunks = 